<div edsGrid [ngClass]="{ 'has-edit-button': page.isPreview() }">
  <ng-container
    *ngIf="page.isPreview()"
    [brManageContentButton]="document"
    documentTemplateQuery="new-Staggered-box"
    folderTemplateQuery="new-Staggered-box-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
</div>
<div
  *ngIf="staggeredBoxesDocument"
  [id]="staggeredBoxesDocument.sectionId"
  [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
>
  <eds-staggered-boxes
    [hasSupportTextLeft]="supportTextLeft"
    [hasSupportTextRight]="supportTextRight"
    [hasFourBoxes]="showfourBoxes"
    [pretitle]="staggeredBoxesDocument.preTitle"
    [title]="staggeredBoxesDocument.title"
    [summary]="gettext(staggeredBoxesDocument.summary)"
    [numberOne]="staggeredBoxesDocument.cards[0]?.preTitle"
    [headingOne]="staggeredBoxesDocument.cards[0]?.title"
    [bodyOne]="gettext(staggeredBoxesDocument.cards[0]?.content)"
    [numberTwo]="staggeredBoxesDocument.cards[1]?.preTitle"
    [headingTwo]="staggeredBoxesDocument.cards[1]?.title"
    [bodyTwo]="gettext(staggeredBoxesDocument.cards[1]?.content)"
    [numberThree]="staggeredBoxesDocument.cards[2]?.preTitle"
    [headingThree]="staggeredBoxesDocument.cards[2]?.title"
    [bodyThree]="gettext(staggeredBoxesDocument.cards[2]?.content)"
    [numberFour]="staggeredBoxesDocument.cards[3]?.preTitle"
    [headingFour]="staggeredBoxesDocument.cards[3]?.title"
    [bodyFour]="gettext(staggeredBoxesDocument.cards[3]?.content)"
    [version]="theme ? theme : 'primary'"
  >
  </eds-staggered-boxes>
</div>

<!-- no document -->
<div *ngIf="!staggeredBoxesDocument && page.isPreview()" class="no-document">
  <div edsGrid class="no-document__component">
    <div class="no-document__overlay">
      Click to configure <strong>Staggered Content</strong>
    </div>
  </div>
</div>
